import * as React from 'react'

interface OrderNoOptionMessageProps {
  innerProps: React.HTMLAttributes<HTMLElement>
  children: React.ReactNode
}

function OrderNoOptionMessage({ innerProps, children }: OrderNoOptionMessageProps) {
  return (
    <tr {...innerProps}>
      <td colSpan={6}>{children}</td>
    </tr>
  )
}

export default OrderNoOptionMessage
